export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Contracts.components.Participants'

export const CONTRACTS_LOAD_PARTICIPANTS = 'CONTRACTS_LOAD_PARTICIPANTS'
export const CONTRACTS_PARTICIPANTS_DATA_RECEIVED = 'CONTRACTS_PARTICIPANTS_DATA_RECEIVED'
export const CONTRACTS_LOAD_PARTICIPANTS_REQUEST = (entId, docId) =>
    `CONTRACTS_${entId}_LOAD_${docId}_PARTICIPANTS_REQUEST`
export const CONTRACTS_PARTICIPANTS_LOADING_TRUE = 'CONTRACTS_PARTICIPANTS_LOADING_TRUE'
export const CONTRACTS_PARTICIPANTS_LOADING_FALSE = 'CONTRACTS_PARTICIPANTS_LOADING_FALSE'
